<div class="as-row as-justify-end">
  <mat-icon svgIcon="ic-close-green" class="as-pointer" mat-dialog-close></mat-icon>
</div>
@if (data === 'terms') {
  <div>
    <p class="as-font-24 as-font-bold center" innerHtml="{{ 'TERMS.title' | translate }}"></p>
    <p innerHtml="{{ 'TERMS.message' | translate }}"></p>
  </div>
}
@if (data === 'privacy') {
  <div>
    <p class="as-font-24 as-font-bold center" innerHtml="{{ 'PRIVACY.title' | translate }}"></p>
    <p innerHtml="{{ 'PRIVACY.message' | translate }}"></p>
  </div>
}
<p class="center as-font-bold">ATENTAMENTE:</p>
<p class="center as-font-bold">Operadora Futurama S.A de C.V y empresas filiales. Calle paseo de las facultades</p>
<p class="center as-font-bold">#601. Chihuahua Chih. Mex.</p>